import React, {Component} from 'react';
import PropTypes from 'prop-types';
import store from 'store';

import {Button, Card, CardBody, CardImg, CardTitle} from "reactstrap";

import group from "../../assets/svg/icons/np_group.svg";
import bedrooms from "../../assets/svg/icons/np_bed.svg";
import bathrooms from "../../assets/svg/icons/np_shower.svg";

import PolyUtil from "../../util/PolyUtil";
import {Link} from "react-router";

class ListingCard extends Component {
    render() {
        const {listing, parent} = this.props;
        const {display_address, identifier, city, state, prop} = listing;
        console.log("Listing:", listing);
        let url = prop.image;

        if (url === null) {
            url = PolyUtil.buildStreetViewUrl(600, 440, display_address + "," + city + "," + state);
        }
        return (
            <Card className="mb-3">
                <CardImg top width="80%" src={url}/>
                <CardBody>
                    <CardTitle className="text-center" style={{marginTop: '-1rem'}}><strong>{PolyUtil.formatUSD(listing.rent)}/month</strong></CardTitle>
                    <div className="d-flex justify-content-center">
                        <strong>{display_address + (identifier ? ', #' + identifier : '')}</strong>
                    </div>
                    <div className="d-flex justify-content-center">
                        <small>{city}, {state}</small>
                    </div>
                    <div className="d-flex flex-row justify-content-center">
                        <span style={{margin: "15px"}}><img src={group} width="30px" alt="Maximum Tenants"/> <strong>{prop.max_tenants}</strong></span>
                        <span style={{margin: "15px"}}><img src={bedrooms} width="30px" alt="Bedrooms"/> <strong>{prop.bedrooms}</strong></span>
                        <span style={{margin: "15px"}}><img src={bathrooms} width="30px" alt="Bathrooms"/> <strong>{parseFloat(prop.bathrooms)}</strong></span>
                    </div>
                    <hr/>
                    <div className="d-flex justify-content-center">
                        <Button outline color="info" block tag={Link} to={"/listings/" + listing.apply_key}  onClick={() => store.set('prev', parent)}>
                            View Listing
                        </Button>
                    </div>
                </CardBody>
            </Card>
        );
    }
}

ListingCard.propTypes = {
    listing: PropTypes.object.isRequired,
    parent: PropTypes.string.isRequired,
};

export default ListingCard;



// WEBPACK FOOTER //
// ./src/components/properties/ListingCard.js